import UnifiedTimeline from "../../shared/Timeline/UnifiedTimeline";

/** @deprecated Use UnifiedTimeline. Thin wrapper for KYC staff review. */
export default function KycReviewTimeline({ entries = [] }) {
  return <UnifiedTimeline items={entries} showActor emptyMessage="No timeline entries yet." />;
}
